import axios from "axios";
import { API_BE4FE_URL } from "../config";
import { RootState } from "../reducers/store";
import { createHttpHeaderWithAuthorization } from "../services/http-header";

export const GET_ORDERS_START = "GET_ORDERS_START";
export const GET_ORDERS_SUCCESS = "GET_ORDERS_SUCCESS";
export const GET_ORDERS_ERROR = "GET_ORDERS_ERROR";
export const GET_ORDER_DOCUMENT_START = "GET_ORDER_DOCUMENT_START";
export const GET_ORDER_DOCUMENT_SUCCESS = "GET_ORDER_DOCUMENT_SUCCESS";
export const GET_ORDER_DOCUMENT_ERROR = "GET_ORDER_DOCUMENT_ERROR";

export const getRecentOrders = () => {
    return (dispatch: any, getState: () => RootState) => {
        return new Promise(function (resolve, reject) {
            const main = getState().main;
            const itemId = main.companyUuid || main.accountantUuid;
            dispatch({ type: GET_ORDERS_START });
            axios
                .get(
                    `${API_BE4FE_URL}/orders?itemId=${itemId}&offset=0&limit=10`,
                    {
                        headers: dispatch(
                            createHttpHeaderWithAuthorization(true),
                        ),
                    },
                )
                .then((result) => {
                    dispatch({
                        type: GET_ORDERS_SUCCESS,
                        payload: result.data,
                    });
                    resolve(result.data);
                })
                .catch((e) => {
                    dispatch({ type: GET_ORDERS_ERROR });
                    reject(e);
                });
        });
    };
};

export const getAllOrders = () => {
    return async (dispatch: any, getState: () => RootState) => {
        const main = getState().main;
        const itemId = main.companyUuid || main.accountantUuid;
        dispatch({ type: GET_ORDERS_START });

        const headers = dispatch(createHttpHeaderWithAuthorization(true));

        const pageSize = 1000;
        let offset = 0;
        let curDataSize = 0;
        let allOrders: any[] = [];

        try {
            do {
                const url = `${API_BE4FE_URL}/orders?itemId=${itemId}&offset=${offset}&limit=${pageSize}`;

                const result = await axios.get(url, { headers });

                const data = result.data;
                curDataSize = data?.length || 0;
                offset = offset + pageSize;

                // Merge result
                allOrders = allOrders.concat(data);
            } while (curDataSize === pageSize);

            dispatch({
                type: GET_ORDERS_SUCCESS,
                payload: allOrders,
            });

            return allOrders;
        } catch (e) {
            dispatch({ type: GET_ORDERS_ERROR });
            throw e;
        }
    };
};

export const getOrderDocument = (orderId: string, format: string) => {
    return (dispatch: any, getState: () => RootState) => {
        return new Promise(function (resolve, reject) {
            const main = getState().main;
            const itemId = main.companyUuid || main.accountantUuid;
            dispatch({ type: GET_ORDER_DOCUMENT_START });
            axios
                .get(
                    `${API_BE4FE_URL}/orders/${orderId}/documents/format/${format}?itemId=${itemId}`,
                    {
                        headers: dispatch(
                            createHttpHeaderWithAuthorization(true),
                        ),
                        responseType: "arraybuffer",
                        responseEncoding: "binary",
                    },
                )
                .then((result) => {
                    dispatch({
                        type: GET_ORDER_DOCUMENT_SUCCESS,
                        payload: result.data,
                    });
                    resolve(result.data);
                })
                .catch((e) => {
                    dispatch({ type: GET_ORDER_DOCUMENT_ERROR });
                    reject(e);
                });
        });
    };
};

export const getOrderJson = (orderId: string) => {
    return (dispatch: any, getState: () => RootState) => {
        return new Promise(function (resolve, reject) {
            const main = getState().main;
            const itemId = main.companyUuid || main.accountantUuid;
            dispatch({ type: GET_ORDER_DOCUMENT_START });
            axios
                .get(
                    `${API_BE4FE_URL}/orders/${orderId}/documents/format/JSON?itemId=${itemId}`,
                    {
                        headers: dispatch(
                            createHttpHeaderWithAuthorization(true),
                        ),
                    },
                )
                .then((result) => {
                    dispatch({
                        type: GET_ORDER_DOCUMENT_SUCCESS,
                        payload: result.data,
                    });
                    resolve(result.data);
                })
                .catch((e) => {
                    dispatch({ type: GET_ORDER_DOCUMENT_ERROR });
                    reject(e);
                });
        });
    };
};
